import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AccountExtRouter } from './account.router';
import { reducers } from './state/account.selectors';

@NgModule({
  imports: [
    AccountExtRouter,
    StoreModule.forFeature('account', reducers),
  ],
  declarations: []
})
export class AccountExtScreenModule { }